import {Component, OnInit, Input, Inject} from '@angular/core';
import {Situation} from "./situation";
import {PatientsManagerService} from "../../patients-manager.service";

@Component({
  selector: 'taxihandgo-situation',
  templateUrl: './situation.component.html',
  styleUrls: ['./situation.component.scss']
})
export class SituationComponent implements OnInit {

  private _situation: Situation;
  constructor() { }

  ngOnInit() {
  }

  @Input()
  get situation(): Situation {
    return this._situation;
  }

  set situation(s: Situation){
    if (PatientsManagerService.transportType != "txi"){
      s.tiers_payant_reglementaire = "OUI";
    }
    this._situation = s;
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/situation/situation.component.ts